import { IMarketModel, MarketModel } from './market-model'

//IMPORTANT: this file is auto-generated, any changes included will not be persisted, if extension is required please inherit from this class in separate file and inlcude your changes there

export interface IBasketHeaderModel {
  id?: number;
  name?: string;
  //isArchived?: boolean;
  basketType?: string;
  ownerId?: string;

  contentCount?: number;
  lastEdited?: Date;
  effectiveFrom?: Date;
  securityTypes?: string[];
  canEdit?: boolean;
  markets?: IMarketModel[];
}

export class BasketHeaderModel implements IBasketHeaderModel {
  constructor(
    public id: number,
    public name: string,
    // public isArchived: boolean,
    public basketType: string,
    public ownerId: string,
    public contentCount: number,
    public lastEdited: Date,
    public effectiveFrom: Date,
    public securityTypes?: string[],
    public canEdit?: boolean,
    public markets?: MarketModel[]
  ) {

  }

  public static empty() {
    return new BasketHeaderModel(null, null, null, null, null, null, null, null, null, null);
  }
}


